import * as actionTypes from "../actionTypes";
import firebase, { database } from "../firebase";
import * as constants from "../Constatnts";
import axios from "axios";

export function savePrintConfig(printConfig, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/setup/stores/printconfig/${key}`,
          printConfig,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/setup/store/printconfig`,
          printConfig,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function deletePrintConfig(key){
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.delete(
        `${constants.API_URL}/setup/stores/printconfig/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
        return true
      }
      else{
        return false
      }
   
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function getPrintConfigsList(registrationID, storeID){
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/setup/printconfig/${storeID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.printConfigs;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getPrintConfigs(registrationID, storeID) {
  return async (dispatch, getState) => {
    // let addMessage = firebase.functions().httpsCallable("getPrintConfigs");
    // return addMessage({
    //   registrationID: registrationID,
    //   storeID: storeID,
    // }).then(function(result) {
    //   // console.log(result.data)
    //   let printConfigs = result.data;
    //   dispatch({ type: actionTypes.PRINT_CONFIG_GET, printConfigs });
    // });
    //9 Mar 26
    const token = getState().user.uat;
    const response = await axios.get(
      constants.API_URL + "/setup/printconfig/" + storeID,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response && response.data && response.data.printConfigs) {
      let printConfigs = response.data.printConfigs;
      dispatch({ type: actionTypes.PRINT_CONFIG_GET, printConfigs });
      //   return printConfigs;
    }
  };
}





export function pushPrintConfigToRedux(printConfig) {
  return (dispatch) => {
    dispatch({ type: actionTypes.PUSH_PRINT_CONFIG_TO_REDUX, printConfig });
  };
}
